import React from 'react';
import { PERIOD_OPTIONS, getPeriod } from '../config';

/**
 * The 1 week / 1,3,6 months / 1-5 years control.
 *
 * One component, not one per period: selecting a period changes exactly one
 * thing - the `days` value sent to the historical endpoint. The period and the
 * active factor tab are independent axes, so giving each period its own file
 * would mean 9 x 7 combinations of near-identical markup.
 */
const PeriodSelector = ({ value, onChange }) => {
  const selected = getPeriod(value);

  return (
    <div className="mt-4">
      <h3 className="text-sm font-medium text-gray-700 mb-3">Historical Comparison Period</h3>

      <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-2">
        {PERIOD_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`px-3 py-2 text-xs rounded-lg transition-all duration-200 ${
              value === option.value
                ? 'bg-blue-600 text-white shadow-md transform scale-105'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            title={option.description}
            aria-pressed={value === option.value}
          >
            <div className="flex flex-col items-center space-y-1">
              <span className="text-sm">{option.icon}</span>
              <span className="font-medium">{option.label}</span>
            </div>
          </button>
        ))}
      </div>

      <p className="text-xs text-center text-blue-600 mt-3">
        {selected.icon} Comparing current values to {selected.description.toLowerCase()}
      </p>
    </div>
  );
};

export default PeriodSelector;
